<markant-platform-ui-page-header class="headline">
  {{ 'organization.gln.headline' | transloco }}

  <markant-button
    actions
    class="headline-button"
    colorScheme="primary"
    variant="clear"
    id="popover-select"
    (click)="addGln()"
  >
    <markant-icon icon="m_plus" slot="icon-leading"></markant-icon>
    {{ 'organization.gln.add' | transloco }}
  </markant-button>
</markant-platform-ui-page-header>

<markant-platform-table
  [data]="tableData$ | async"
  [defaultHeaderCells]="tableDraft.headerAndTableCells"
  [loading]="(isLoading$ | async) ?? false"
  [showPagination]="false"
>
</markant-platform-table>

<markant-platform-modal-bridge *ngIf="openDeleteDialog || openAddModal">
  <markant-dialog
    *ngIf="openDeleteDialog"
    class="gln-dialog-delete"
    [open]="true"
    [headTitle]="'organization.gln.dialog.delete.headline' | transloco"
    (close)="closeDialog()"
  >
    <p class="dialog-text">
      {{
        'organization.gln.dialog.delete.text'
          | transloco
            : {
                glnValue: selectedGln.value,
                organizationName: selectedGln.organizationName,
              }
      }}
    </p>

    <div slot="footer">
      <markant-button
        colorScheme="primary"
        variant="clear"
        class="button-transparent-secondary-text"
        (click)="closeDialog()"
      >
        {{ 'organization.gln.dialog.delete.cancelButton' | transloco }}
      </markant-button>

      <markant-button colorScheme="primary" (click)="onSubmit('delete')">
        {{ 'organization.gln.dialog.delete.approveButton' | transloco }}
      </markant-button>
    </div>
  </markant-dialog>

  <markant-dialog
    *ngIf="openAddModal"
    class="gln-dialog-add"
    [open]="true"
    [headTitle]="'organization.gln.dialog.add.headline' | transloco"
    (close)="closeDialog()"
  >
    <p class="dialog-text">
      {{
        'organization.gln.dialog.add.text'
          | transloco: { organizationName: selectedGln.organizationName }
      }}
    </p>

    <form [formGroup]="inputForm" class="gln-form">
      <markant-input
        *ngIf="inputForm.controls['gln'] as glnControl"
        name="gln"
        data-cy="input-gln"
        [required]="true"
        [formControlName]="'gln'"
        [label]="'organization.gln.glnLabelText' | transloco"
        [maxlength]="13"
        [showLabelHint]="true"
        [helperCharacterCounter]="true"
        [placeholder]="'organization.gln.addGlnPlaceholder' | transloco"
        [error]="
          inputForm.hasError('duplicatedGln') ||
          (glnControl.errors
            | formControlError: glnControl.touched || glnControl.dirty)
        "
        [errorText]="
          'organization.gln.validation.' +
            (inputForm.hasError('duplicatedGln')
              ? 'duplicate'
              : glnControl.hasError('invalidGln')
                ? 'invalidGln'
                : 'pattern') | transloco
        "
      ></markant-input>

      <div slot="footer">
        <markant-button
          class="button-transparent-secondary-text"
          colorScheme="primary"
          variant="clear"
          (click)="closeDialog()"
        >
          {{ 'organization.gln.dialog.add.cancelButton' | transloco }}
        </markant-button>

        <markant-button
          colorScheme="primary"
          [disabled]="inputForm.invalid"
          (click)="onSubmit('add')"
        >
          {{ 'organization.gln.dialog.add.approveButton' | transloco }}
        </markant-button>
      </div>
    </form>
  </markant-dialog>
</markant-platform-modal-bridge>
